import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHookSection() {
  return <section className="py-24 px-4 bg-navy-900 relative" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="prose prose-lg prose-invert mx-auto" data-id="element-176">
          <h3 className="text-3xl md:text-4xl font-display text-amber-300 mb-8 italic text-center" data-id="element-177">
            "Son las 3:00 AM."
          </h3>

          <div className="space-y-6 text-cream-100/90 font-body text-lg leading-relaxed font-light" data-id="element-178">
            <p data-id="element-179">
              Estás sentada en el borde de la cama, con los ojos ardidos y el
              monitor en la mano, rogando que el próximo suspiro de tu bebé no
              se convierta en un llanto.
            </p>
            <p data-id="element-180">
              Sientes que has fallado, que "algunas suertudas tienen bebés que
              duermen" y que a ti te tocó el difícil. El cansancio no es solo
              falta de sueño; es una neblina mental que afecta tu paciencia, tu
              trabajo y tu relación de pareja.
            </p>
            <p className="text-xl text-cream-50 font-medium pt-4" data-id="element-181">
              Pero no tiene por qué ser así.
            </p>
            <p data-id="element-182">
              Tu bebé no "nació mal dormilón", simplemente no ha aprendido la
              habilidad de descansar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}